import { PaymentMethodDto } from '../../api/PaymentProvider/Types/PaymentMethodDto'
import { ApiClient } from './ApiClient'

export class PaymentApiClient {
  constructor(private apiClient: ApiClient) {}
  getPaymentProviders: () => Promise<PaymentMethodDto[]> = () => {
    return this.apiClient.get(`npayments/lists/methods`)
  }
}
